import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import Breadcrumbs from '@/components/Breadcrumbs'
import SubmittalStatusPill from '@/components/SubmittalStatusPill'
import ChevronLeft from '@/assets/svgs/chevron-left.svg?react'
import { formatDate } from '@/utils/formatDate'
import { SUBMITTAL_STATUS } from '../constants'

export const SubmittalHeader = ({
  elementName,
  status,
  projectContractName,
  submissionMonth,
  modified,
}) => {
  const navigate = useNavigate()
  const breadcrumbItems = [
    { label: '', link: '/submittals', isHomePage: false },
    { label: 'Submittals', link: '/submittals' },
    { label: 'Details' },
  ]

  return (
    <>
      <Breadcrumbs breadcrumbItems={breadcrumbItems} />
      <div className="flex items-start gap-3">
        <button
          type="button"
          className="sm:inline-flex hidden shrink-0 items-center justify-center w-9 h-9 p-0 mt-0.5 border-0 rounded-full bg-grey-95 cursor-pointer transition-colors duration-150 ease-in-out hover:bg-grey-90 focus:bg-grey-90 active:bg-grey-90 hover:outline-none focus:outline-none active:outline-none [&_svg]:w-5 [&_svg]:h-5 [&_svg_path]:fill-grey-10"
          onClick={() => navigate('/submittals')}
          aria-label="Back to submittals"
        >
          <ChevronLeft />
        </button>
        <div className="flex flex-col gap-2 min-w-0 flex-1">
          <div className="flex flex-row items-center gap-2">
            <div className="sm:type-header-3 type-header-4 font-[900] min-w-0 truncate">
              {elementName || ''}
            </div>
            <SubmittalStatusPill status={status} />
          </div>
          <div className="flex sm:flex-row flex-col sm:items-center sm:gap-2 gap-1 font-avenir-medium text-grey-50 type-meta-medium">
            {projectContractName && <span>Project Contract Name: {projectContractName}</span>}
            {projectContractName && submissionMonth && (
              <span className="font-avenir-heavy text-grey-50 type-meta-heavy sm:inline hidden">
                ·
              </span>
            )}
            {submissionMonth && <span>Submission Month: {submissionMonth}</span>}
          </div>
          {modified && (
            <div className="font-avenir-medium text-grey-50 type-meta-medium">
              Last updated on: {formatDate(modified)}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

SubmittalHeader.propTypes = {
  elementName: PropTypes.string,
  status: PropTypes.string,
  projectContractName: PropTypes.string,
  submissionMonth: PropTypes.string,
  modified: PropTypes.string,
}
